import React from "react";
import closeImg from "../Assets/Images/close.png";
const Alert = ({ type, msg, onClose }) => {
  return (
    <div
      className={`alert-box ${
        type === "success"
          ? "alert-box--success"
          : type === "error"
          ? "alert-box--error"
          : ""
      }`}
    >
      <div>{msg}</div>
      <div>
        <img className="close-btn" src={closeImg} alt="بستن" onClick={onClose} />
      </div>
    </div>
  );
};

export default Alert;
